import { FunctionComponent, h } from 'preact'

import classes from '../components/TextInputComp/index.scss'
import otherInputClasses from './index.scss'

import { useTranslation } from 'scripts/hooks'
import { TextInputCompProps } from '../components/TextInputComp/type'
import cls from 'classnames'

const OtherChoiceInput: FunctionComponent<TextInputCompProps> = (props) => {
  const { className = '', value, onChange, placeholder } = props
  const t = useTranslation()

  const handleChange = (evt: any) => {
    onChange(evt.target.value)
  }

  return (
    <textarea
      className={cls(classes.input, otherInputClasses.otherChoiceInput, className)}
      value={value}
      onChange={handleChange}
      placeholder={placeholder || t('otherChoicePlaceholder')}
    />
  )
}

export default OtherChoiceInput
